export default "__VITE_ASSET__HCbpxf_V__"